var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Table',{ref:"table",attrs:{"loadObj":{},"option":{
      importBtn: true,
    },"colObj":{
      opId:3534,
      name:"数据迁移列映射",
      parentId:"SETUP_ID",
      parentName:"外部数据实体管理",
      parentPath:"/system/trans/outerSetup",
      parentQuery:{
      },
      addForm:{
      },
      dataClass:2,
      col:[]
    }}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }